export default "__VITE_ASSET__4c87b3d6__"